import * as React from 'react';

import { observer } from 'mobx-react';

import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { useLanguage } from '~utils/hooks/language';

import { LanguageSwitcherController } from './LanguageSwitcherController';
import { TextLink } from './TextLink';

export type LanguageSwitcherConfiguration = {
    staticLookupName?: string;
    languages: PreferredLanguage[];
};

export type PreferredLanguage = {
    name: string;
    languageKey: string;
    redirectedURL: string;
    label?: string;
    languageIndex?: number;
    languageId: number;
    isActive?: boolean;
    isDefault?: boolean;
};

export const LanguageSwitcher = observer((props: LanguageSwitcherConfiguration) => {
    const language = useLanguage();

    const viewController = React.useMemo<LanguageSwitcherController>(
        () => diContainer.get(serviceNames.languageSwitcherController),
        []
    );

    React.useEffect(() => {
        const loadDataStore = async () => {
            await viewController.loaded(language, props);
        };

        loadDataStore();
    }, []);

    return (
        <div className="elc-iam-language-switcher">
            {viewController?.data?.map(({ name, redirectedURL, label = '', isActive }) => (
                <TextLink
                    key={name}
                    name={name}
                    url={redirectedURL}
                    inputLabel={label}
                    isActive={isActive}
                />
            ))}
        </div>
    );
});
